import React from 'react';
import { Card, Typography, Box } from '@mui/material';
import { LineChart } from '@mui/x-charts/LineChart';
import { useSelector } from 'react-redux';
import { percentageFormatter } from "../../redux-store/dashboardSlice/selectorsUtils"
import { selectMonthlyProgressChartData } from "../../redux-store/dashboardSlice/dashboardSliceSelectors"
import { IconButton, styled } from '@mui/material';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
    backgroundColor: '#E6F7FF', // Light blue background
    color: '#009EFF', // Icon color
    padding: theme.spacing(2),
    '&:hover': {
        backgroundColor: '#D0F0FF', // Slightly darker on hover
    },
}));


export const MonthlyProgressBlock = () => {
    const chartData = useSelector((state) => selectMonthlyProgressChartData(state));

    if (!chartData) return null;

    return (
        <Card sx={{ my: { xs: 1, md: "10px" } }}>
            <Box p={2}>
                <Box display="flex" alignItems="center" px={1}>
                    <Typography variant="subtitle1" fontWeight={600} flexGrow={1}>Monthly Progress</Typography>
                    <StyledIconButton>
                        <CalendarMonthRoundedIcon fontSize="small" />
                    </StyledIconButton>
                </Box>
                <Box display="flex" flexGrow={1}>
                    <LineChart
                        dataset={chartData}
                        xAxis={[{ scaleType: "point", dataKey: "month" }]}
                        yAxis={[
                            {
                                dataKey: "finsihRate",
                                valueFormatter: percentageFormatter,
                            },
                        ]}
                        series={[
                            {
                                dataKey: "finsihRate",
                                valueFormatter: percentageFormatter,
                                color: "#00aaff",
                            },
                        ]}
                        width={500}
                        height={270}
                    />
                </Box>
            </Box>
        </Card>
    )
}


